import React from 'react';
import { GetBrandedTutorName, GetBrandedAppName } from '../../../services/BrandingService';

export const getFaqData = (t) => ({
    yellow_flag: {
        title: 'What does it mean that some of the text is shown in yellow?',
        Content: e => {
            return (
                <div>
                    <div>Phrases that show in yellow were hard for ${GetBrandedTutorName()} to score.</div>  
                    <div>This may be because of the student’s approach to reading or because of issues with the audio.</div> 
                    <div>Issues may include:</div>
                    <ul>
                        <li>Network Bandwidth</li>
                        <li>Background Noise</li>
                        <li>Soft Talking</li>
                        <li>Problems With The Microphone.</li>
                    </ul>
                    <div>If you want to understand this better, play the audio.</div>
                </div>
            )
        }
    },
    looks_wrong: {
        title: 'What do I do if I think this score is way off?',
        Content: e => {
            return (
                <div>
                    You have two quick options:
                    <ol>
                        <li>If {GetBrandedTutorName()} provided a score, rescore by clicking on words where you disagree with {GetBrandedAppName()}'s' scoring</li>
                        <li>If {GetBrandedTutorName()} designated this student as a prereader but you think this student is able to read, assign a new assessment in the Tracking Report</li>
                    </ol>
                    <div>But, we’d really like to improve the scoring. </div> 
                    <div>Submit this activity for improvement.</div>
                </div>
            )
        }
    },
    inconsistent_time: {
        title: t("inconsistent_time_title"),
        Content: e => t("inconsistent_time_content")
    },
    default: {
        title: t("default_title"),
        Content: e => {
            return (
                <div>
                    {t("default_content")}
                    <a className="faq-link" href='https://help.amiralearning.com/s/article/How-do-I-listen-to-how-students-read-with-Amira' target="_blank"> {t("this link")}</a>.
                </div>
            )
        }
    },
    under_review: {
        title: 'Why is this not scored yet and under review?',
        Content: e => {
            return (
                <div>
                    <div>If the audio has issues or the student is on the border around dyslexia risk, the Assessment goes thru a second scoring process to ensure the best possible assessment scoring.</div>
                    <div>Your assessment will be scored NO LATER than 3 days after the test was taken.  However, the VAST MAJORITY of reviews are done overnight and the final score is available the next day.</div>
                </div>
            )
        }
    },
    unscoreable_test:{
        title: 'Why Isn’t This Test Scored?',
        Content: e => {
            return (
                <div>
                    <div>The student did not correctly read enough words for {GetBrandedAppName()} to measure Oral Reading Fluency.</div>
                    <div>This may be because of the student’s reading ability or because the test audio had problems.</div>
                    <div>Sometimes background noise or a student not paying attention to the test can result in an Unscoreable outcome.</div>
                    <div>If you think that the student is able to read, please re-assess (assign a new assessment in the Tracking Report).</div>
                </div>
            )
        }
    },
    not_trying: {
        title: "Did this student give best effort?",
        Content: e => {
            return (
                <div>
                    <div>Based on the pattern of mistakes, it's possible the student didn't make the best effort.</div>
                    <div>You may want to listen to the audio of the student reading.</div>
                </div>
            )
        }
    },
    early_next_button: {
        title: t("early_next_button_title"),
        Content: e => t("early_next_button_content")
    },
    yellow_flag_practice: {
        title: "What does the yellow highlighting of text mean during a Practice session?",
        Content: e => {
            return (
                <div>
                    <div>When scoring practice, text in yellow might mean:</div>
                    <ul>
                        <li>{GetBrandedTutorName()} intervened for a struggling student and read the text first and the student repeated after. You might notice the student recording sounds more fluent or confident than you normally experience with this student.  You should assume the child is repeating ${GetBrandedTutorName()} and may not be able to independently read these words.</li>
                        <li>The network on the device was slow and {GetBrandedTutorName()} could not assess the reading with high confidence.  The reading will sound typical of this student and we recommend you listen to the recording and click the words to adjust the score accordingly.</li>
                    </ul>
                </div>
            )
        }
    },
    minimum_scoring: {
        title: "It looks like this student only read a few words. What should I do?",
        Content: e => {
            return (
                <div>
                    <div>{GetBrandedTutorName()} will assess reading mastery whenever the student reads enough to enable reliable and valid estimation of their ability.</div>
                    <div>In this case, the amount of reading was just above that threshold.</div>
                    <div>{GetBrandedTutorName()}'s accuracy will therefore be far less than normal based on the minimal information for analysis.</div>
                    <div>Consequently, if you believe the student is a stronger or weaker reader than {GetBrandedTutorName()} is indicating, you should reassess.</div>
                </div>
            )
        }
    },
    reassess: {
        title: "Should this student re-assessed?",
        Content: e => {
            return (
                <div>
                    <div>There are some signs and signals that re-assessing this student might product meaningfully different results.</div>
                    <div>Listen to the audio and compare {GetBrandedTutorName()}'s assessed mastery to your own estimate of this student's ability.</div>
                    <div>If there is a meaningful discrepancy, you should re-assess the student.</div>
                </div>
            )
        }
    }
})